import styled, { css } from 'styled-components';

interface ColumnProps {
  noMargin?: boolean;
}

export const Column = styled.div<ColumnProps>`
  ${({ noMargin }) =>
    !noMargin &&
    css`
      margin-right: 40px;
    `}
`;

export const Divider = styled.div`
  width: 1px;
  height: 20px;
  margin: 0 40px;
  background-color: ${({ theme }) => theme.colors.gray700};
`;
